import { HashLoader } from "react-spinners";

/** Shown while a lazy-loaded route chunk is downloading. */
export default function PageLoadFallback() {
  return (
    <div
      className="fixed inset-0 z-[9998] flex items-center justify-center"
      style={{
        background: "rgba(248, 250, 252, 0.82)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
      }}
      aria-busy="true"
      aria-label="Loading"
    >
      <HashLoader size={60} color="#4f46e5" />
    </div>
  );
}
